import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getInspectionBuilder } from '../../REST/inspections';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';

export default function InspectionMasterList() {
    const navigate = useNavigate()
    const [formsList, setFormsList] = useState(null)

    useEffect(() => {
        (async () => {
            const resp = await getInspectionBuilder()
            setFormsList(resp?.data || [])
        })()
    }, [])

    return (
        <PageShell>
            <PageHeader title="Inspection" back onBack={() => navigate(-1)} />

            <PageContent sx={{ p: { xs: 2, md: 3 } }}>
                {formsList == null ? (
                     <></>
                ) : formsList.length === 0 ? (
                    <Typography variant="body1" sx={{ textAlign: 'center' }}>
                        No Master Inspection added yet. Please click <Link to="/settings/inspection">here</Link> to proceed.
                    </Typography>
                ) : (
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: 'repeat(2, minmax(0, 1fr))',
                                lg: 'repeat(4, minmax(0, 1fr))',
                            },
                            gap: 2,
                        }}
                    >
                        {formsList.map((item, index) => (
                            <Box
                                key={item?._id ?? index}
                                id="each-form"
                                onClick={() => navigate(`inspectionList/${item?._id}`)}
                                sx={{
                                    cursor: 'pointer',
                                }}
                                title={item?.name || ''}
                            >
                                <Box className="bg-light rounded">
                                    <Typography component="h5" noWrap title={item?.name || ''}>
                                        {item?.name}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}
            </PageContent>
        </PageShell>
    )
}

